// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import { makeServiceRequest } from "../ServiceRequest";
import type RequestOptions from "../RequestOptions";
import type GetMasterCategoryListRequest from "../contract/GetMasterCategoryListRequest";
import type MasterCategoryListActionResponse from "../contract/MasterCategoryListActionResponse";
import getMasterCategoryListRequest from "../factory/getMasterCategoryListRequest";

export default function getMasterCategoryListOperation(req: {
    request: GetMasterCategoryListRequest;
}, options?: RequestOptions): Promise<MasterCategoryListActionResponse> {
    if (req.request !== undefined && !req.request["__type"]) {
        req.request = getMasterCategoryListRequest(req.request);
    }
    
    return makeServiceRequest<MasterCategoryListActionResponse>("GetMasterCategoryList", req, options);
}
